export default "<p>\n  monitor-alerts works!\n</p>\n";